import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import axiosInstance from "../../api/axiosInstance";

interface SmsCampaignReportDawnload {
    id?: number;
    receiver_number: string;
    status?: number;
    retry_status?: number;
    createdAt: string;
    sms_gateway: {
        name: string
        id: number
    };
    sms_gateways_number: {
        gateway_number: string;
    }
    length: number;
}


interface SmsCampaignReportState {
    smscampaignreportdawnlaoddata: SmsCampaignReportDawnload[];
    info: { count: number; current_page: number; limit: number; total_page: number } | null;
    error: string | null;
    loading: boolean;
}

interface SmsCampaignListParams {
    id: number;
    sms_gateway_name?: string;
    sms_gateway?: number;
    gateway_id?: number;
    gateway_number?: string;
    receiver_number?: string;
    attempt?: number;
    sort_field?: string;
    sort?: 'ASC' | 'DESC';
    status?: number;
    retry_status?: number;
    limit: number;
    page: number;
}

interface SmsCampaignReportResponse {
    data: SmsCampaignReportDawnload[];
    info: {
        count: number;
        current_page: number;
        limit: number;
        total_page: number;
    };
}

export const GetallSmsCampaignReportDawnlaod = createAsyncThunk<
    Blob, // Change the return type to Blob
    SmsCampaignListParams,
    { rejectValue: string }
>(
    'GetallSmsCampaignReportDawnlaod',
    async (params, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/api/admin/reports/sms-campaign-list/download/${params.id}`, {
                params: {
                    'sms_gateway.name': params.sms_gateway_name,
                    gateway_id: params.sms_gateway === 0 ? '' : params.sms_gateway,
                    'sms_gateways_number.gateway_number': params.gateway_number,
                    receiver_number: params.receiver_number,
                    attempt: params.attempt,
                    sort_field: params.sort_field,
                    sort: params.sort,
                    status: params.status,
                    retry_status: params.retry_status,
                    page: params.page,
                    limit: params.limit
                },
                responseType: 'blob' // Specify that you expect a Blob response
            });
            return response.data; // Return the Blob directly
        } catch (error: any) {
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data);
            }
            return rejectWithValue(error.message);
        }
    }
);



const initialState: SmsCampaignReportState = {
    smscampaignreportdawnlaoddata: [],
    info: null,
    error: null,
    loading: false,
};

const smscampaignreportdawnloadSlice = createSlice({
    name: "Smscampaignreportdawnlaod",
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // ===============get-all-smtp-slice-start============
            .addCase(GetallSmsCampaignReportDawnlaod.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(GetallSmsCampaignReportDawnlaod.fulfilled, (state, action: PayloadAction<Blob>) => {
                state.loading = false;
            })
            .addCase(GetallSmsCampaignReportDawnlaod.rejected, (state, action: PayloadAction<string | undefined>) => {
                state.loading = false;
                state.error = action.payload || 'An error occurred';
            });
        // ===============get-all-smtp-slice-end============      
    },
});


export default smscampaignreportdawnloadSlice.reducer;
